import React, {Component} from 'react';
import axios from "axios";

import send from '../../../assets/logos/send_fr.svg';

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

export default class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prenom: "",
            nom: "",
            email: "",
            objet: "",
            message: "",
            lang: 'en',
            trad: en,
        }
    }

    componentDidMount() {
        if (JSON.parse(localStorage.getItem("user"))) {
            this.setState({
                user: JSON.parse(localStorage.getItem("user")),
            }, () => {
                let lang = this.state.user.user.language;
                if (lang === "fr") {
                    this.setState({lang: "fr", trad: fr});
                }
            });
        }
    }

    handleSendMessage = () => {
        let url = import.meta.env.VITE_BACKEND_URL + '/contact/send';
        axios.post(url, {
            prenom: this.state.prenom,
            nom: this.state.nom,
            email: this.state.email,
            objet: this.state.objet,
            message: this.state.message,
        }).then((response) => {
            console.log(response);
        }).catch((error) => {
            console.log(error);
        });
    }

    render() {
        const {trad} = this.state;
        return (
            <div className="page_contact">
                <div className="titre">
                    <h1>{trad.contactTitle}</h1>
                </div>
                <div className="formulaire_contact">
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact1}</label><br/>
                        <input onChange={(e) => this.setState({prenom: e.target.value})} value={this.state.prenom}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact2}</label><br/>
                        <input onChange={(e) => this.setState({nom: e.target.value})} value={this.state.nom}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact3}</label><br/>
                        <input onChange={(e) => this.setState({email: e.target.value})} value={this.state.email}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact4}</label><br/>
                        <input onChange={(e) => this.setState({objet: e.target.value})} value={this.state.objet}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="prenom">{trad.contact5}</label><br/>
                        <textarea
                            onChange={(e) => this.setState({message: e.target.value})}>{this.state.message}</textarea>
                    </div>
                    <div className="form-group-edit">
                        <button onClick={this.handleSendMessage}>
                            <img src={send} alt=""/>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
